/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon20Solid = forwardRef('ArrowDim2DiagMinRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.296 3.296a1.125 1.125 0 0 0-1.591-1.591l-4.58 4.579V4a1.125 1.125 0 0 0-2.25 0v4.25c0 1.036.84 1.875 1.875 1.875H16a1.125 1.125 0 0 0 0-2.25h-2.284l4.58-4.58Z" }),
        React.createElement("path", { d: "M7.875 16v-2.284l-4.58 4.58a1.125 1.125 0 0 1-1.59-1.591l4.579-4.58H4a1.125 1.125 0 0 1 0-2.25h4.25c1.036 0 1.875.84 1.875 1.875V16a1.125 1.125 0 0 1-2.25 0Z" })));
});
